import theme from "@/lib/theme"
import AdminPage from "@/routes/Admin"
import AdminLogin from "@/routes/Auth/AdminLogin"
import DocumentDownload from "@/routes/Auth/Documents"
import LoginRedirect from "@/routes/Auth/LoginRedirect"
import ResetPassword from "@/routes/Auth/ResetPassword"
import VerifyEmail from "@/routes/Auth/VerifyEmail"
import VerifySMS from "@/routes/Auth/VerifySMS"
import Cart from "@/routes/Cart"
import Checkout from "@/routes/Checkout"
import CountyAdminPage from "@/routes/CountyAdmin"
import Dashboard from "@/routes/Dashboard"
import { MantineProvider } from "@mantine/core"
import { ModalsProvider } from '@mantine/modals'
import { Notifications } from "@mantine/notifications"
import { BrowserRouter, Route, Routes } from "react-router"
import { AuthProvider } from "../Auth"
import CountyAdminRoute from "../Auth/CountyAdminRoute"
import CustomerSupportRoute from "../Auth/CustomerSupportRoute"
import ProtectedRoute from "../Auth/ProtectedRoute"
import { CartProvider } from "../Cart"
import FAQ from "../FAQ"
import { HubProvider } from "../Hub"
import { InvoiceProvider } from "../Invoice"
import Layout from "../Layouts/Layout"
import PrintMetrics from "../Metrics/PrintMetrics"
import Privacy from "../Privacy"
import Register from "../Register"
import Support from "../Support"
import Terms from "../Terms"
import Welcome from "../Welcome"
import "./App.css"



function App() {
  return (
    <MantineProvider theme={theme}>
      <ModalsProvider>
        <BrowserRouter>
          <AuthProvider>
            <HubProvider>
              <CartProvider>
                <InvoiceProvider>
                  <Routes>
                    <Route element={<Layout />}>
                      <Route index element={<Welcome />} />
                      <Route path="/admin-login" element={<AdminLogin />} />
                      <Route path="/faq" element={<FAQ />} />
                      <Route path="/support" element={<Support />} />
                      <Route path="/register" element={<Register />} />
                      <Route path="/terms" element={<Terms />} />
                      <Route path="/privacy" element={<Privacy />} />
                      <Route path="/login-redirect/:code" element={<LoginRedirect />} />
                      <Route path="/reset-password/:code" element={<ResetPassword />} />
                      <Route path="/documents/:folder/:file" element={<DocumentDownload />} />
                      <Route path="/verify-email/:code" element={<VerifyEmail />} />
                      <Route path="/verify-sms/:code" element={<VerifySMS />} />
                      <Route element={<ProtectedRoute />}>
                        <Route path="/dashboard" element={<Dashboard />} />
                        <Route path="/cart" element={<Cart />} />
                        <Route path="/checkout" element={<Checkout />} />
                      </Route>
                      <Route element={<CustomerSupportRoute />}>
                        <Route path="/admin" element={<AdminPage />} />
                      </Route>
                      <Route element={<CountyAdminRoute />}>
                        <Route path="/county-admin" element={<CountyAdminPage />} />
                      </Route>
                    </Route>
                    <Route element={<ProtectedRoute />}>
                      <Route path="/print-metrics" element={<PrintMetrics />} />
                    </Route>
                  </Routes>
                </InvoiceProvider>
              </CartProvider>
            </HubProvider>
          </AuthProvider>
        </BrowserRouter>
      </ModalsProvider>
      <Notifications  />
    </MantineProvider>
  )
}

export default App
